/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   let variant = event.detail.variant; // Get the variant that was added
 *   let quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Deeply merges properties of source objects into a target object.
 * Arrays are concatenated, not merged by index.
 * Primitives and non-object values are overwritten.
 *
 * @param {object} target The object to merge properties into.
 * @param {...object} sources The source objects whose properties will be merged.
 * @returns {object} The target object with merged properties.
 */
function deepmerge(target, ...sources) {
  if (!target || typeof target !== 'object') {
    throw new Error('Deepmerge target must be an object.');
  }

  // Loop through each source object provided
  for (const source of sources) {
    // Skip if the source is not an object or is null
    if (!source || typeof source !== 'object') {
      continue;
    }

    // Iterate over the keys of the current source object
    for (const key in source) {
      // Ensure the key is a direct property of the source object (not inherited)
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        const sourceValue = source[key];
        const targetValue = target[key];

        // Check if both source and target values are objects (and not arrays or null)
        if (
          typeof sourceValue === 'object' &&
          sourceValue !== null &&
          typeof targetValue === 'object' &&
          targetValue !== null &&
          !Array.isArray(sourceValue) &&
          !Array.isArray(targetValue)
        ) {
          // Recursively merge if both are non-array objects
          target[key] = deepmerge(targetValue, sourceValue);
        } else if (Array.isArray(sourceValue) && Array.isArray(targetValue)) {
          // Concatenate arrays
          target[key] = targetValue.concat(sourceValue);
        } else {
          // For primitives, non-object values, or when types don't match (e.g., object merging with a primitive)
          // overwrite the target value with the source value.
          target[key] = sourceValue;
        }
      }
    }
  }

  return target;
}

window.Shopify.getCart = async function () {
  let fetchUrl = window.Shopify.routes.root + 'cart.js';

  let response = await fetch(fetchUrl, {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
  });

  let cart = await response.json();

  return cart;
};

window.addEventListener('DOMContentLoaded', function () {
  // Hide Rewards Toggle
  setTimeout(() => {
    if (!document.body.classList.contains('hide-rewards')) {
      window.defer(() => {
        const targetNode = document.querySelector('mini-cart');
        if (!targetNode) return;

        const config = { attributes: true, childList: true, subtree: false };
        const callback = (mutationList, observer) => {
          for (const mutation of mutationList) {
            console.log('Rewards toggle mutation');
            const cartIsOpen = document.querySelector('mini-cart')?.getAttribute('data-open');

            if (cartIsOpen == 'true' && !document.body.classList.contains('hide-rewards')) {
              document.body.classList.add('hide-rewards');
            }
          }
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
      }, 'mini-cart');
    }
  }, 1000);

  function addToCartFromForm(elem, additionalData = []) {
    let variantId =
      elem.getAttribute('data-variant-id') ?? document.querySelector('.product-form__variants [name="id"]')?.value;
    let variant = window.PDP.productData.variants.find(function (variant) {
      return +variant.id === +variantId;
    });

    let qty = elem.getAttribute('data-qty') ?? 1;
    let referrer = elem.getAttribute('data-referrer');
    let isSubscription = !!document.querySelector('[data-selector-subsave] input:checked');
    let sellingPlan = isSubscription
      ? {
          name: document
            .querySelector('.subscription-options .rc_widget__option__selector input')
            ?.getAttribute('name'),
          selectedValue: document.querySelector('.Product .rc_widget__option__plans__dropdown')?.value,
        }
      : {};
    if (
      referrer === 'scroll-subnav' &&
      !window.PDP.variantsInteracted &&
      document.querySelector('.shade-selector-modal__wrapper')
    ) {
      document
        .querySelectorAll('.shade-selector-modal__bg, .shade-selector-modal__wrapper')
        .forEach((el) => el.classList.toggle('visible', true));
      document.documentElement.classList.toggle('no-scroll', true);
      document.body.classList.toggle('shade-selector-open', true);
      moveSecondarySubscriptionWidget();
    } else {
      if (referrer === 'shade-selector-modal') {
        document
          .querySelectorAll('.shade-selector-modal__bg, .shade-selector-modal__wrapper')
          .forEach((el) => el.classList.toggle('visible', false));
        document.documentElement.classList.toggle('no-scroll', false);
        document.body.classList.toggle('shade-selector-open', false);
      }

      return addToCartWithCartUpdate(variant, qty, isSubscription, sellingPlan, additionalData);
    }
  }

  function setHeaderHeightProperties() {
    const header = document.querySelector('#section-medispa-header,#section-header');
    if (!header) return;

    const headerHeight = header.clientHeight;
    let secondaryNavHeight =
      window.outerWidth < 1008
        ? document.querySelector('.Search')?.clientHeight
        : document.querySelector('nav.Header__MainNav')?.clientHeight;

    if (secondaryNavHeight == null) return;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--secondary-nav-height', secondaryNavHeight + 'px');
  }

  setHeaderHeightProperties();

  window.addEventListener('resize', function () {
    setHeaderHeightProperties();
  });

  document.querySelectorAll('.collection-description').forEach((el) => {
    el.addEventListener('click', function (event) {
      event.preventDefault();
      if (el.classList.contains('inline')) {
        el.classList.remove('inline');
        el.textContent = 'Read Less';
        document.querySelectorAll('.SectionHeader__Description').forEach((desc) => desc.classList.remove('inline'));
      } else {
        el.classList.add('inline');
        el.textContent = 'Read More';
        document.querySelectorAll('.SectionHeader__Description').forEach((desc) => desc.classList.add('inline'));
      }
    });
  });

  function updateRecentProducts() {
    let isPDP = !!document.querySelector('body.template-product');

    if (!isPDP) return;

    let productHandle = window.location.pathname.split('/').pop();

    let existingEntries = localStorage.getItem('recently-viewed-products');

    existingEntries = existingEntries ? JSON.parse(existingEntries) : [];

    // Remove existing versions of this handle from the list
    existingEntries = existingEntries.filter(function (entry) {
      return entry !== productHandle;
    });

    existingEntries.unshift(productHandle);

    localStorage.setItem('recently-viewed-products', JSON.stringify(existingEntries));
  }

  document.querySelectorAll('.medispa-dropdown-trigger').forEach((trigger) => {
    trigger.addEventListener('click', function () {
      trigger.classList.toggle('open');
      trigger.closest('.booking-wrapper')?.classList.toggle('open');
    });
  });

  function rawAddToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity,
            properties: {
              _source: 'theme:rawAddToCart',
            },
          },
        ],
      }),
    }).then((resp) => resp.json());
  }

  function addPromoLabels(items) {
    if (!!window?.theme?.packOptions?.labels?.cart_message) {
      items.forEach((item) => {
        // const unitPriceDollars = item.final_price / 100;
        // const priceThreshold = window?.theme?.gift_product?.price_threshold;
        if (item.quantity >= 3) {
          item.properties['Promotion'] = window.theme.packOptions.labels.cart_message;
        }
      });
    }

    return items;
  }

  function __addToCart(variant, quantity, isSubscription, sellingPlan, additionalData) {
    return new Promise(function (resolve, reject) {
      let payload = {
        form_type: 'product',
        utf8: '✓',
        items: [
          {
            properties: {
              _barcode: variant.sku,
              _source: 'theme:__addToCart',
            },
            id: variant.id,
            quantity: quantity,
          },
        ],
      };

      payload.items = addPromoLabels(payload.items);

      if (additionalData?.length) {
        payload.items.push(...additionalData);
      }

      const promotionLabel = additionalData?.find((item) => !!item?.properties?._promotion);

      if (promotionLabel) {
        payload.items[0].properties['_promotion'] = promotionLabel.properties._promotion;
        // window.clarity('set', 'promotion', promotionLabel.properties._promotion);
      }

      payload.items.forEach((item, idx) => {
        // window.clarity('set', `item_add_${idx}`, `${item.id}:${item.quantity}`);
      });

      // if (quantity >= window.theme.gift_product.required_amount) {
      //   payload.items[0].properties['_promotion'] = 'b3g3';
      // }

      payload[sellingPlan.name] = isSubscription ? 'subsave' : 'onetime';
      if (isSubscription) payload['selling_plan'] = sellingPlan.selectedValue;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      })
        .then((resp) => resp.json())
        .then(resolve)
        .catch(reject);
    });
  }

  function addToCartWithCartUpdate(variant, qty, isSubscription, sellingPlan, additionalData) {
    return new Promise(function (resolve, reject) {
      try {
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        __addToCart(variant, qty, isSubscription, sellingPlan, additionalData)
          .then(function () {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            document.dispatchEvent(
              new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: variant.id,
                  quantity: qty,
                },
              }),
            );
          })
          .then(resolve)
          .catch(function (err) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            console.trace(err);
            console.error(err.statusText);

            reject(err.responseJSON.description);
          });
      } catch (e) {
        reject(e);
      }
    });
  }

  function clearSwatchFilters() {
    document.querySelectorAll('label.ColorSwatch[data-category]').forEach((elem) => {
      elem.closest('.js-variant')?.classList.toggle('hidden', false);
    });
  }

  function syncQuantities(newQuantity, packMultiple = 1) {
    document.querySelectorAll('.product-form__quantity input.product-form__quantity-input').forEach((input) => {
      input.value = newQuantity;
    });
    document.querySelectorAll(".product-form__add-to-cart[data-action='add-to-cart'][data-qty]").forEach((btn) => {
      btn.setAttribute('data-qty', String(newQuantity * packMultiple));
    });
  }

  document.querySelectorAll('.product-form__quantity-input').forEach((input) => {
    input.addEventListener('change', function () {
      let updatedVal = input.value;

      syncQuantities(
        updatedVal,
        parseInt(document.querySelector('[data-bundle-option].active')?.getAttribute('data-pack-multiple') || '1'),
      );
    });
  });

  function setSwatchFilter(group) {
    document.querySelectorAll('label.ColorSwatch[data-category]').forEach((elem) => {
      let elemGroups = elem.dataset.category.split('$$');
      let matchesFilter = elemGroups.indexOf(group) !== -1;
      elem.closest('.js-variant')?.classList.toggle('hidden', !matchesFilter);
    });
  }

  function getOrCreateOverlayBg() {
    let bg = document.querySelector('.generic-overlay-bg');

    if (!bg) {
      bg = document.createElement('div');
      bg.className = 'generic-overlay-bg';
      document.body.appendChild(bg);
    }

    return bg;
  }

  function getOrCreateVideoPlayer() {
    let wrapper = document.querySelector('.video-overlay__wrapper');
    let video = wrapper?.querySelector('video') ?? null;

    if (!wrapper || !video) {
      wrapper = document.createElement('div');
      wrapper.className = 'video-overlay__wrapper';

      video = document.createElement('video');
      video.autoplay = true;
      video.controls = true;
      video.append('Your browser does not support the video tag.');

      wrapper.appendChild(video);
      document.body.appendChild(wrapper);
    }

    return { wrapper, video };
  }

  function closeVideoOverlay() {
    const wrapper = document.querySelector('.video-overlay__wrapper.visible');
    if (!wrapper) return;

    wrapper.classList.remove('visible');
    wrapper.querySelector('video')?.pause();
    document.querySelector('.generic-overlay-bg')?.classList.remove('visible');
    document.documentElement.style.overflow = '';
  }

  function watchVideo(event, actionEl) {
    event.preventDefault();

    const rawConfig = actionEl.dataset.videoConfig;
    if (!rawConfig) return;

    let videoConfig;

    try {
      videoConfig = JSON.parse(decodeURIComponent(rawConfig));
    } catch (error) {
      console.error('watch-video: failed to parse data-video-config', error);
      return;
    }

    const sources = (videoConfig.sources ?? []).filter((source) => source.url && source.mime_type);

    if (!sources.length) {
      console.error('watch-video: video config has no playable sources');
      return;
    }

    const { wrapper, video } = getOrCreateVideoPlayer();
    const bg = getOrCreateOverlayBg();

    video.querySelectorAll('source').forEach((sourceEl) => sourceEl.remove());

    for (const source of sources) {
      const sourceEl = document.createElement('source');
      sourceEl.src = source.url;
      sourceEl.type = source.mime_type;
      video.appendChild(sourceEl);
    }

    const [first] = sources;
    if (first.width) video.width = first.width;
    if (first.height) video.height = first.height;

    if (videoConfig.aspect_ratio) {
      wrapper.style.setProperty('--aspect-ratio', String(videoConfig.aspect_ratio));
    }

    wrapper.classList.add('visible');
    bg.classList.add('visible');
    document.documentElement.style.overflow = 'clip';

    video.load();
    video.play().catch(() => {});
  }

  document.body.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;

    if (e.target.closest('.generic-overlay-bg.visible')) {
      closeVideoOverlay();
    }

    const elem = e.target.closest('.js-action');
    if (!elem) return;

    let action = elem.getAttribute('data-action');

    if (!action) return;

    switch (action) {
      case 'open-modal': {
        e.preventDefault();
        let targetSelector = elem.getAttribute('data-target');
        if (!targetSelector) return;
        let targets = document.querySelectorAll(targetSelector);
        if (!targets.length) return;
        targets.forEach((target) => target.classList.toggle('visible', true));
        break;
      }
      case 'close-modal': {
        e.preventDefault();
        let targetSelector = elem.getAttribute('data-target');
        if (!targetSelector) return;
        let targets = document.querySelectorAll(targetSelector);
        if (!targets.length) return;
        targets.forEach((target) => {
          target.classList.toggle('visible', false);
          target.querySelectorAll('video').forEach((v) => v.pause());
        });
        document.documentElement.classList.toggle('no-scroll', false);
        document.documentElement.style.overflow = '';
        break;
      }
      case 'close-modal-self': {
        e.preventDefault();
        elem.classList.toggle('visible', false);
        document.documentElement.classList.toggle('no-scroll', false);

        elem.querySelectorAll('video').forEach((v) => v.pause());
        break;
      }
      case 'toggle-tab': {
        let targetSelector = elem.getAttribute('data-target');
        let scopeSelector = elem.getAttribute('data-scope');
        let scope = (scopeSelector && document.querySelector(scopeSelector)) || elem.parentElement;
        if (!scope) return;

        scope.querySelectorAll('.tab-header').forEach((tabHeader) => {
          tabHeader.classList.toggle('active', false);
          let elemTarget = tabHeader.getAttribute('data-target');
          if (elemTarget) {
            document.querySelector(elemTarget)?.classList.toggle('active', false);
          }
        });
        let target = scope.querySelector(targetSelector);
        elem.classList.toggle('active', true);
        target?.classList.toggle('active', true);
        let parent = elem.parentElement;
        if (!parent) return;
        let activeItem = parent.querySelector('.active');
        if (!activeItem) return;
        let tabHeaders = parent.querySelectorAll('.tab-header');
        let numTabs = tabHeaders.length;
        let activeIndex = Array.prototype.indexOf.call(tabHeaders, activeItem);
        let activeItemWidth =
          activeIndex === numTabs - 1
            ? parent.getBoundingClientRect().width - activeItem.offsetLeft
            : activeItem.offsetLeft + activeItem.getBoundingClientRect().width;
        let activeleftOffset = activeIndex === 0 ? 0 : activeItem.offsetLeft;
        parent.style.setProperty('--num-tabs', numTabs);
        parent.style.setProperty('--active-item-width', activeItemWidth);
        parent.style.setProperty('--active-item-left-offset', activeleftOffset);
        break;
      }
      case 'add-to-cart': {
        e.preventDefault();
        document.body.classList.add('hide-rewards');

        // Purchase 3 to get gift modal
        window.PurchaseGiftManager.showModal().then(async function ({ status }) {
          // const selectedPack = document.querySelector('[data-bundle-option].active');

          // let packGifts;

          // if (selectedPack) {
          //   const selectedPackGifts = JSON.parse(selectedPack.getAttribute('data-bundle-gifts'));

          //   const groupedGifts =
          //     await window.PurchaseGiftManager.sortGiftsByCartStatus(selectedPackGifts);

          //   packGifts = window.PurchaseGiftManager.createGiftsPayloads(groupedGifts);

          //   console.debug(packGifts);
          // }

          // let parsedGifts = await window.PurchaseGiftManager.parseCartGifts(),
          //   mergedGifts = await window.PurchaseGiftManager.parseCartGifts();

          // if (packGifts?.notInCart?.length) {
          //   mergedGifts.notInCart.payload.push(...packGifts.notInCart);
          // }

          // if (packGifts?.inCart) {
          //   mergedGifts.inCart.payload = deepmerge(parsedGifts.inCart.payload, packGifts.inCart);
          // }

          // console.debug('Parsed gifts', parsedGifts);
          // console.debug('Merged gifts', mergedGifts);

          if (status === 'user-rejected') {
            return addToCartFromForm(elem);
          }

          if (status === 'not-eligible') {
            return addToCartFromForm(elem);
          }

          if (status === 'not-needed') return addToCartFromForm(elem);

          if (status === 'add-multiple') {
            elem.setAttribute('data-qty', window.theme.gift_product.required_amount);
            return addToCartFromForm(elem);
          }
        });
        break;
      }
      case 'add-variant-to-cart': {
        let variantId = elem.getAttribute('data-variant-id');
        let qty = elem.getAttribute('data-qty') ?? 1;

        rawAddToCart(variantId, qty);
        document.body.classList.add('hide-rewards');

        break;
      }
      case 'change-swatch-group': {
        let group = elem.getAttribute('data-group');
        if (!group) clearSwatchFilters();
        else setSwatchFilter(group);
        let sibling = elem.parentElement?.children;
        if (sibling) {
          Array.from(sibling).forEach((sib) => {
            if (sib !== elem && sib.classList.contains('active')) {
              sib.classList.toggle('active', false);
            }
          });
        }
        elem.classList.toggle('active', true);
        break;
      }
      case 'change-carousel-position': {
        // This has been moved into a variant:changed listener
        break;
      }
      case 'decrease-quantity':
      case 'increase-quantity': {
        let qtyInput = null;
        let sibling = elem.parentElement?.children;
        if (sibling) {
          qtyInput = Array.from(sibling).find((sib) => sib.matches?.('input.product-form__quantity-input'));
        }
        let updatedVal = qtyInput?.value;

        let packMultiple = parseInt(
          document.querySelector('[data-bundle-option].active')?.getAttribute('data-pack-multiple') || '1',
        );

        if (isNaN(packMultiple)) {
          console.error('Could not find pack multiple element! Defaulting to 1');

          packMultiple = 1;
        }

        syncQuantities(updatedVal, packMultiple);
        break;
      }
      case 'open-calendar': {
        e.preventDefault();
        e.stopImmediatePropagation();

        // Insert products fragment into config, then open calendar
        const startEl = e.target instanceof Element ? e.target : elem;
        let fragmentContent = null;

        if (startEl) {
          let currentEl = startEl;

          while (currentEl && currentEl !== document.documentElement) {
            fragmentContent =
              currentEl.querySelector?.('script[data-medispa-products-fragment]') ||
              currentEl.querySelector?.("script[id^='medispa-products-fragment-']");

            if (fragmentContent) break;

            currentEl = currentEl.parentElement;
          }
        }

        if (fragmentContent) {
          console.debug('Fragment content:', fragmentContent);

          const products = JSON.parse(fragmentContent.textContent);

          console.debug('Products:', products);

          window.theme.medispaCalendarConfig.products = products;
          window.theme.medispaCalendarConfig.selectedProduct = products[0].id.toString();

          if (products[0]) {
            window.theme.medispaCalendarConfig.depositAmount = products[0].deposit_amount;
            window.theme.medispaCalendarConfig.payInStoreAmount = products[0].pay_in_store_amount;
          }

          // document.dispatchEvent(
          //   new CustomEvent('theme:medispaCalendarConfig', {
          //     detail: window.theme.medispaCalendarConfig,
          //   }),
          // );
        }

        const mainCta = e.target.closest('[data-product-id]');

        if (!mainCta) return;

        console.debug('Opening calendar', mainCta);

        const productId = mainCta.getAttribute('data-product-id');
        if (!productId) return;

        window.theme.medispaCalendarConfig.selectedProduct = productId;

        document.dispatchEvent(
          new CustomEvent('theme:medispaCalendarConfig', {
            detail: window.theme.medispaCalendarConfig,
          }),
        );

        document.documentElement.classList.add('lock-scrolling');

        // Uncomment later for calendar rework
        const calendarElem = document.querySelector('.medispa-calendar--placeholder');
        if (!calendarElem) return;

        calendarElem.classList.add('active');

        break;
      }
      case 'open-call-modal': {
        document
          .querySelectorAll('.generic-overlay-bg, .call-us-modal__wrapper')
          .forEach((el) => el.classList.toggle('visible'));
        break;
      }
      case 'watch-video': {
        watchVideo(e, elem);
        break;
      }
      case 'add-required-to-cart': {
        e.preventDefault();

        return window.PurchaseGiftManager.addRequiredForGiftToCart(elem);
      }
      default: {
        console.debug('Unhandled JS event: ', action);
        break;
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeVideoOverlay();
  });

  const cartIconHeader = document.querySelector('#cart_icon_header');
  if (cartIconHeader) {
    cartIconHeader.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      window.dispatchEvent(new CustomEvent('mini-cart:ui:open'));
    });
  }

  document.addEventListener('variant:changed', function (event) {
    console.debug(event);
    let variant = event.detail.variant; // Gives you access to the whole variant details
    document.querySelectorAll('.product-form__quantity input.product-form__quantity-input').forEach((input) => {
      input.value = 1;
    });

    document.querySelectorAll('.purchase-gift__hitpoint').forEach((el) => {
      el.setAttribute('data-variant-id', variant.id);
    });

    document.querySelectorAll('.product-gift-modal__viewport .add-required-to-cart').forEach((el) => {
      el.setAttribute('data-variant-id', variant.id);
    });

    window.PurchaseGiftManager.onVariantChange(variant);

    // Slide to new variant image
    const newFeaturedImageIndex = event.detail.variant.featured_image?.position;

    if (typeof newFeaturedImageIndex === 'number') {
      // Adjust index based on whether it is after the videoly carousel items
      let adjustedIndex = newFeaturedImageIndex;

      if (newFeaturedImageIndex > window.PDP.videolyOffset) {
        adjustedIndex = newFeaturedImageIndex + window.PDP.videolyOffset;
      }

      // console.debug(
      //   `Sliding to index ${adjustedIndex}. New featured image index: ${newFeaturedImageIndex}`,
      // );

      const thumbs = document.querySelector('.product-image-thumbs-wrapper');
      const main = document.querySelector('.product-main-carousel-wrapper');
      thumbs?.swiper?.slideTo(adjustedIndex - 1);
      main?.swiper?.slideTo(adjustedIndex - 1);
    }
  });

  updateRecentProducts();

  function moveSecondarySubscriptionWidget() {
    let isMobile = window.outerWidth < 960;

    if (isMobile) {
      const options = document.querySelector('.scroll-subnav .subscription-options');
      const target = document.querySelector(".ProductForm__AddToCart[data-referrer='shade-selector-modal']");
      if (options && target?.parentNode) {
        target.parentNode.insertBefore(options, target);
      }
    } else {
      const options = document.querySelector('.shade-selector-modal__wrapper .subscription-options');
      const target = document.querySelector('.scroll-subnav .product-actions');
      if (options && target?.parentNode) {
        target.parentNode.insertBefore(options, target);
      }
    }
  }

  moveSecondarySubscriptionWidget();
  window.addEventListener('resize', moveSecondarySubscriptionWidget);

  // Emphasise BNDL code
  window.defer(function () {
    let widgetDescription = document.querySelector(
      '.widget-type-dynamic-bundle .rebuy-widget-container.is-visible .rebuy-widget-content .description',
    );

    if (!widgetDescription) return;

    widgetDescription.innerHTML = widgetDescription.innerHTML.replace(
      /BNDL/g,
      "<strong class='bundle-code'>BNDL</strong>",
    );
  }, '.widget-type-dynamic-bundle .rebuy-widget-container.is-visible .rebuy-widget-content .description');

  window.deferJS(
    () => {
      setTimeout(() => {
        const atcSkeleton = document.querySelector('.buttons.product-form__button .button-skeleton');

        if (!atcSkeleton) return;

        atcSkeleton.classList.add('!hidden');
      }, 1000);
    },
    () => {
      return typeof klaviyo.init !== 'undefined';
    },
  );
});
